export const toolbarLabel = "qNa";
export const singleLineRibbonLabel = "rNa";
export const multiLineRibbonLabel = "sNa";
export const layoutHeaderLabel = "tNa";
export const ribbonLayoutButtonLabel = "uNa";
export default {toolbarLabel,singleLineRibbonLabel,multiLineRibbonLabel,layoutHeaderLabel,ribbonLayoutButtonLabel};